import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=aa8c750a&scoped=true&"
import script from "./createRole.vue?vue&type=script&lang=js&"
export * from "./createRole.vue?vue&type=script&lang=js&"
import style0 from "./createRole.vue?vue&type=style&index=0&id=aa8c750a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8c750a",
  null
  
)

export default component.exports